export const Header = () => {
  return (
    <header className="p-4">
      <div className="navbar bg-primary text-primary-content rounded-box">
        <button className="btn btn-ghost text-xl">AUX退職代行</button>
      </div>
    </header>
  );
};
